export default "__VITE_ASSET__CJUmefvo__"